import { Injectable } from '@angular/core';
import { BusinessAreaEnum } from 'app/core/enums/generated/BusinessAreaEnum';
import { BA_Style } from './fa-business-area-icons.service';

@Injectable({
  providedIn: 'root',
})
export class FaBusinessIconsNotSolid {
    getIconByBusinessArea(ba: BusinessAreaEnum) {
        return BA_Style[ba].regularIcon;
    }    

    getIconStyleByBusinessArea(ba: BusinessAreaEnum) {
        return {
            color: BA_Style[ba].color,
            background: BA_Style[ba].background
        };
    }
}
